@if (form) {
  <section class="px-7 flex flex-col items-center mt-12 gap-y-2.5 font-main mb-9">
    <svg-icon [src]="'add-large'"></svg-icon>

    <p class="font-bold text-4xl text-navy-90">{{ buildTranslationKey('title') | translate }}</p>

    <p class="text-navy-70 text-base text-center whitespace-pre-line">
      {{ buildTranslationKey('description') | translate: { count: maxFilesCount, maxSize: maxFilesWeight } }}
    </p>

    @if (tipTemplate) {
      <ng-container *ngTemplateOutlet="tipTemplate"></ng-container>
    }

    <div class="w-full mt-3.5">
      <dynamic-form-outlet [dynamicFormGroup]="form"></dynamic-form-outlet>
    </div>
  </section>

  <section class="h-17.5 bg-navy-30 px-7.5 flex items-center justify-between mt-auto gap-5">
    <div class="flex-1 flex items-center gap-2.5">
      <svg-icon
        class="text-navy-60 w-4.5"
        [src]="'info'"
        [ngbTooltip]="buildTranslationKey('infoTooltip') | translate">
      </svg-icon>

      <span class="text-navy-70 font-main text-base whitespace-pre-line">
        {{ buildTranslationKey('footerInfo') | translate }}
      </span>
    </div>

    <app-new-button
      data-test-id="upload-files-btn"
      [type]="'primary'"
      [size]="'responsive'"
      [disabled]="!isFormValid"
      [clickOnEnter]="true"
      [loading]="isLoading$ | async"
      (click)="handleCTAClick()"
    >
      {{ buildTranslationKey('confirmBtn') | translate }}
    </app-new-button>
  </section>
}
